import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuSelect } from "../../components/neu/Neu";
import { listBranches } from "../../api/directory";
import { listWarehouses } from "../../api/warehouse";
import { listStandards } from "../../api/gl";
import { localName } from "../../lib/localName";

const currencyOf = (b) => b?.primary_currency || b?.payroll?.currency || "AED";

// اختيار الفرع والمخزن — العملة والضريبة الافتراضية تُشتقّان من النظام المحاسبي للفرع.
export const BuilderDelivery = ({ head, onChange }) => {
  const { t, i18n } = useTranslation();
  const ar = i18n.language === "ar";
  const [branches, setBranches] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [standards, setStandards] = useState([]);

  useEffect(() => {
    listBranches().then((d) => setBranches(d || [])).catch(() => setBranches([]));
    listStandards().then((d) => setStandards(d?.items || [])).catch(() => setStandards([]));
  }, []);

  useEffect(() => {
    if (!head.delivery_branch_id) { setWarehouses([]); return; }
    listWarehouses(head.delivery_branch_id)
      .then((d) => setWarehouses(d?.items || d || []))
      .catch(() => setWarehouses([]));
  }, [head.delivery_branch_id]);

  const vatOfBranch = (b) => {
    if (!b) return 0;
    const std = standards.find((s) => s.code === (b.accounting_standard || ""));
    return std?.vat_default_rate != null ? Number(std.vat_default_rate) : 0;
  };

  // ضامن: عند تحميل الفروع والمعايير، وحّد العملة والضريبة الافتراضية للفرع الحالي.
  useEffect(() => {
    if (!head.delivery_branch_id || !branches.length || !standards.length) return;
    const b = branches.find((x) => x.id === head.delivery_branch_id);
    if (!b) return;
    const c = currencyOf(b);
    const v = vatOfBranch(b);
    if (head.currency !== c || head.tax_default_pct !== v) {
      onChange({ ...head, currency: c, tax_default_pct: v,
        tax_percent: head.tax_default_pct == null ? v : head.tax_percent });
    }
  }, [branches, standards, head.delivery_branch_id]);

  const setBranch = (e) => {
    const b = branches.find((x) => x.id === e.target.value);
    const c = currencyOf(b);
    const v = vatOfBranch(b);
    onChange({ ...head, delivery_branch_id: e.target.value || null,
      branch_id: e.target.value || null, delivery_warehouse_id: null,
      currency: c, tax_default_pct: v, tax_percent: v, tax_amount: "" });
  };
  const setWarehouse = (e) => onChange({ ...head, delivery_warehouse_id: e.target.value || null });
  const label = (r) => localName(r, r.code || r.id);

  return (
    <>
      <label className="grid gap-1.5">
        <span className="text-[11px] font-bold text-muted-foreground">
          {t("purchases.deliveryBranch")}
          {head.currency ? <span className="mx-1 text-primary">· {head.currency}</span> : null}
        </span>
        <NeuSelect data-testid="purchase-delivery-branch"
                   value={head.delivery_branch_id || ""} onChange={setBranch}>
          <option value="">{t("purchases.pickBranch")}</option>
          {branches.map((b) => (
            <option key={b.id} value={b.id}>{label(b)}</option>
          ))}
        </NeuSelect>
      </label>
      <label className="grid gap-1.5">
        <span className="text-[11px] font-bold text-muted-foreground">
          {t("purchases.deliveryWarehouse")}
        </span>
        <NeuSelect data-testid="purchase-delivery-warehouse"
                   value={head.delivery_warehouse_id || ""} onChange={setWarehouse}
                   disabled={!head.delivery_branch_id}>
          <option value="">{t(head.delivery_branch_id ? "purchases.pickWarehouse" : "purchases.pickBranchFirst")}</option>
          {warehouses.map((w) => (
            <option key={w.id} value={w.id}>{label(w)}</option>
          ))}
        </NeuSelect>
      </label>
    </>
  );
};
